import {
  type ProjectItem,
  useProducts,
  useProject,
} from '@customink/project-service-react-components';
import { useEffect } from 'react';

import { useEcommEvent } from './useEcommEvent';

import { GA_EVENTS } from '@/constants';
import { useAuth } from '@/contexts/auth/AuthContext';

export const useViewCartEvent = () => {
  const { data: project } = useProject();
  const projectItems = project?.items;

  const productIds = projectItems?.reduce(
    (acc: number[], projectItem: ProjectItem) => {
      if (projectItem.product?.colorId) {
        acc.push(projectItem.product.colorId);
      }
      return acc;
    },
    [],
  );
  const { data: products } = useProducts({
    colorIds: productIds || [],
  });

  const { fireEcommEvent } = useEcommEvent();
  const { isLoading: isAuthLoading } = useAuth();

  useEffect(() => {
    if (projectItems && products && !isAuthLoading) {
      fireEcommEvent({
        event: GA_EVENTS.VIEW_CART,
        voucherCode: project?.coreOrder?.voucherCode,
        project,
        products,
      });
    }
  }, [fireEcommEvent, isAuthLoading, products, project, projectItems]);
};
